import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { FormattedMessage, intlShape } from "react-intl";

import { TextInput } from "../../../../../common/form";

import validationUtils from "../../../../../../utils/ValidationUtils";
import { MEMBERS_VALIDATION_RULES } from "../membersValidationRules";

class BasicCustomContactFields extends React.Component {
  getChildContext() {
    return {
      scene: this.props.scene,
    };
  }

  render() {
    return (
      <form onSubmit={this.props.handleSubmit}>
        <Field
          id="customEmailAddress"
          name="customEmailAddress"
          component={TextInput}
          type="text"
          label={<FormattedMessage id="members.form.customEmailAddress" />}
        />
        <Field
          id="customPhoneNumber"
          name="customPhoneNumber"
          component={TextInput}
          type="text"
          label={<FormattedMessage id="members.form.customPhoneNumber" />}
        />
        <Field
          id="customInformation"
          name="customInformation"
          component={TextInput}
          type="text"
          maxLength="40"
          label={<FormattedMessage id="members.form.customInformation" />}
        />
      </form>
    );
  }
}

BasicCustomContactFields.propTypes = {
  scene: PropTypes.string,
  validation: PropTypes.object,
  handleSubmit: PropTypes.func,
};

BasicCustomContactFields.defaultProps = {
  scene: "",
};

BasicCustomContactFields.contextTypes = {
  getData: PropTypes.func,
  intl: intlShape,
};

BasicCustomContactFields.childContextTypes = {
  scene: PropTypes.string,
};

export default connect(null, null, null, { withRef: true })(
  reduxForm({
    form: "basiccustomcontactfields",
    validate: (values) =>
      validationUtils.validate(values, MEMBERS_VALIDATION_RULES),
  })(BasicCustomContactFields)
);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/members/member/BasicCustomContactFields.js